module.exports = __webpack_public_path__ + "static/img/2022.12.6dffe3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyprofilepic/2022.12.jpg
// module id = MKDt
// module chunks = 51